/* REDTEC v2 · miniaturas de cor nos cards das coleções + galeria abrindo na cor selecionada */
(function () {
  if (window.__rtV2) return;
  window.__rtV2 = true;

  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  // Cards das coleções (tema original): troca a bolinha pela foto da própria mala
  function thumbCards(root) {
    (root || document).querySelectorAll('.rtb__product-card').forEach(function (card) {
      if (card.__rtThumbs) return;
      var variants;
      try { variants = JSON.parse(card.dataset.variants || '[]'); } catch (e) { return; }
      if (!variants.length) return;
      card.__rtThumbs = true;
      card.querySelectorAll('.color-swatch[data-variant]').forEach(function (sw) {
        var name = sw.dataset.variant;
        var v = variants.find(function (x) { return x.options && x.options.indexOf(name) > -1 && x.featured_image; });
        if (!v) return;
        sw.style.background = '#FFFFFF url("' + sized(v.featured_image.src, 120) + '") center / contain no-repeat';
        sw.classList.add('rt-swatch-thumb');
      });
    });
  }

  // Página de produto: abrir a galeria na foto da cor que já vem selecionada
  function syncGallery() {
    var el = document.querySelector('.top__wrapper .swipper-container');
    var input = document.querySelector('variant-picker input[data-featured-media-id]:checked');
    if (!el || !el.swiper || !input || !input.dataset.featuredMediaId) return false;
    var slides = el.querySelectorAll('.swiper-slide');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].dataset.mediaId === input.dataset.featuredMediaId) {
        if (el.swiper.activeIndex !== i) el.swiper.slideTo(i, 0);
        return true;
      }
    }
    return true;
  }


  // Página de produto: miniaturas da própria mala no seletor de cor
  var rtQueued = false;
  function pdpThumbs() {
    rtQueued = false;
    var gallery = document.querySelector('.top__wrapper .swipper-container');
    if (!gallery) return;
    var srcById = {};
    gallery.querySelectorAll('.swiper-slide[data-media-id]').forEach(function (s) {
      var img = s.querySelector('img');
      if (img) srcById[s.dataset.mediaId] = (img.getAttribute('data-src') || img.getAttribute('src') || '').split('&width=')[0];
    });
    document.querySelectorAll('variant-picker input[data-color-name][data-featured-media-id]').forEach(function (input) {
      var label = input.closest('label');
      var src = srcById[input.dataset.featuredMediaId];
      if (!label || !src) return;
      var url = sized(src, 160);
      if (label.getAttribute('data-rt-thumb') === url && label.classList.contains('rt-thumb-swatch') && label.style.background.indexOf('url') > -1) return;
      label.setAttribute('data-rt-thumb', url);
      label.classList.add('rt-thumb-swatch');
      label.style.setProperty('background', '#FFFFFF url("' + url + '") center / contain no-repeat', 'important');
    });
  }
  function queuePdp() { if (!rtQueued) { rtQueued = true; requestAnimationFrame(pdpThumbs); } }

  function init() {
    thumbCards(document);
    var tries = 0;
    (function wait() { if (!syncGallery() && tries++ < 40) setTimeout(wait, 100); })();
    pdpThumbs();
    var pending = [];
    var flush = 0;
    new MutationObserver(function (list) {
      var pdp = false;
      list.forEach(function (m) {
        if (m.target.closest && m.target.closest('variant-picker')) pdp = true;
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1 && (n.matches('.rtb__product-card') || n.querySelector('.rtb__product-card'))) pending.push(n); });
      });
      if (pdp) queuePdp();
      if (pending.length && !flush) flush = requestAnimationFrame(function () { flush = 0; var l = pending.splice(0); l.forEach(function (n) { thumbCards(n.parentNode || n); }); });
    }).observe(document.body, { childList: true, subtree: true });
    var vp = document.querySelector('variant-picker');
    if (vp) new MutationObserver(queuePdp).observe(vp, { subtree: true, attributes: true, attributeFilter: ['style'] });
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('variant-picker')) setTimeout(queuePdp, 50); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
